const crsType = {
    type: "name",
    properties: {
        name: "urn:ogc:def:crs:EPSG::25829",
    },
};

export {crsType as default};
